import React, { useEffect, useRef, useState } from "react";
import Loader from '../../Commons/Loader';
import { Link } from 'react-router-dom'
import $ from "jquery";
import axiosInstance from "../../../services/api";
import "datatables.net";
import "../../../../node_modules/datatables.net-dt/css/dataTables.dataTables.min.css"
import "datatables.net-responsive-dt";
import "../../../../node_modules/datatables.net-responsive-dt/css/responsive.dataTables.min.css";

import { toast } from 'react-toastify';
import resetPasswordImg from "../../../assets/images/reset-password.png"
import Swal from "sweetalert2";
import { useMenu } from '../../../context/MenuContext';

function AllUser() {
    const tableRef = useRef(null);
    const [userListingData, setUserListingData] = useState([]); // Set initial state as an empty array
    const [successMessage, setSuccessMessage] = useState(""); 
    const [loading, setLoading] = useState(true);
    const menuArr = useMenu();
    // This function simulates an API call that requires authentication
    const fetchData = async () => {
        try {
            const response = await axiosInstance.get('user/get-all-user'); // Make a GET request
            setUserListingData(response.data.data || []); // Set the entire array of users
        } catch (error) {
            console.error('Error fetching data:', error);
        }finally {
            setLoading(false);
          }
    };

    useEffect(() => {
            fetchData();
    }, []);

    useEffect(() => {
        if (userListingData.length > 0) {
            const table = $(tableRef.current).DataTable({
                destroy: true,  // Destroy previous instance
                paging: true,    // Enable pagination
                searching: true, // Enable search
                lengthChange: true, // Enable show entries dropdown
                ordering: true,  // Enable sorting
                responsive: true,
                autoWidth: false, // Prevents incorrect column resizing
                columnDefs: [
                    { targets: 1, responsivePriority: 1 }, // Name - Always visible
                    { targets: 6, responsivePriority: 2 }, // Operations - Always visible
                    { targets: [1, 2, 3, 4, 5], responsivePriority: 3 } 
                ],
                columns: [
                    { title: "User Type" },
                    { title: "Name" },
                    { title: "Email" },
                    { title: "Designation" },
                    { title: "Enabled" },
                    { title: "2FA" },
                    { title: "Operations"  }
                ]
            });

            return () => {
                table.destroy(); // Clean up DataTable instance on unmount
            };
        }
    }, [userListingData]); // Run when `userListingData` changes
    useEffect(() => {
        const handleResize = () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().columns.adjust().responsive.recalc();
            }
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    // const handleEditUser = async (email, e) =>  {
    //     // Perform navigation or other logic
    //     toast.dismiss();
    //     setLoading(true);
    //     try {
    //         const response = await axiosInstance.post('user/reset-password', {email : email});
    //         console.log(response)
    //         if (response.status === 200) {
    //             console.log("hui")
    //             if(response.data.status.code===200) {
    //                 toast.success(response.data.status.message);
    //                 //setSuccessMessage(response.data.status.message);
    //             }else{
    //                 toast.error(response.data.status.message);
    //             }
    
    //             // setTimeout(() => {
    //             //     setSuccessMessage("");
    //             // }, 2000);
    //         }
    //     } catch (error) {
    //         console.error('Error validating OTP:', error);
    //     }finally {
    //         setLoading(false);
    //     }
    // };

    const handleResetPassword = async (email) => {
        const { isConfirmed } = await Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to reset password?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, reset it!",
            cancelButtonText: "No, cancel!"
        });

        if (!isConfirmed) return;
        setLoading(true);
        try {
            const response = await axiosInstance.post('user/reset-password', {email : email});
            console.log(response)
            if (response.status === 200) {
                console.log("hui")
                if(response.data.status.code===200) {
                    toast.success(response.data.status.message);
                    //setSuccessMessage(response.data.status.message);
                }else{
                    toast.error(response.data.status.message);
                }
            }
        } catch (error) {
            console.error('Error validating OTP:', error);
        }finally {
            setLoading(false);
        }
    };
    const menuArrNw = menuArr.menuArr;
    const checkAddUser = () => {
        return menuArrNw.some(menu =>
            menu.subMenus.some(subMenu => subMenu.id === "add-user")
        );
    };
    const showAddUser = checkAddUser();

    const handleDeleteUser = async (userId) => {
        const { isConfirmed } = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this user?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!"
        });

        if (!isConfirmed) return;

      

        try {
            const payload = { id: userId };
            const response = await axiosInstance.post('user/delete-user', payload);
            console.log("API Response:", response.data);

            if (response.data.status.code === 200) {
                const { message } = response.data.status;
                await Swal.fire({
                    title: "Deleted!",
                    text: message,
                    icon: "success",
                    confirmButtonText: "OK",
                });

                // ✅ Refresh the user list
                setTimeout(() => {
                    //fetchData(); // Refresh the list
                    window.location.reload();
                }, 100);
            } else {
                Swal.fire({
                    title: "Failed!",
                    text: response.data.status.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            console.error("Error deleting user:", error);
            Swal.fire({
                title: "Error!",
                text: "Error deleting user. Please try again.",
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
            setLoading(false);
        }
    };



    return (
        <>
        {loading && <Loader />} 
        <div className="content-header">
            <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-6 title-mob">
                        <h1 className="m-0">All User</h1>
                        {showAddUser && <Link className="btn btn-primary submit-btn" to="/add-user">Add User</Link>}
                    </div>{/* /.col */}
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                            <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                            <li className="breadcrumb-item active">All User</li>
                        </ol>
                    </div>{/* /.col */}
                </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>
        <section className="content">
            <div className="container-fluid border-top pt-4">
                <table ref={tableRef} className="display styled-table user-table">
                    <thead>
                        <tr>
                            <th>User Type</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Designation</th>
                            <th>Enabled</th>
                            <th>2FA</th>
                            <th>Operations</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userListingData.length > 0 && userListingData.map((item, index) => (
                            <tr key={index}>
                                <td>{item.userType}</td>
                                <td>{item.name}</td>
                                <td>{item.email}</td>
                                <td>{item.designation}</td>
                                <td>{item.enabled ? "true" : "false"}</td>
                                <td>{item.tfaEnabled ? "true" : "false"}</td>
                                <td>
                                    {showAddUser && <Link to={`/edit-user/${item.id}`} className="edit">
                                        <i className="nav-icon fas fa-pencil-alt"></i>
                                    </Link>}
                                    <a title="Reset Password" onClick={() => handleResetPassword(item.email)} className="edit reset-link">
                                        <img src={resetPasswordImg} alt="" />
                                    </a>
                                    {item.deletable===true ? <button
                                        className="delete ml-2 btn btn-danger"
                                        onClick={() => handleDeleteUser(item.id)}
                                    >
                                        <i className="nav-icon fas fa-trash-alt"></i>
                                    </button> : ''}
                                    
                                </td>
                            </tr>
                        ))}
                
                    </tbody>
                </table>
            </div>{/* /.container-fluid */}
        </section>
        </>
    );
}

export default AllUser;
